import {Data} from '../../shared/api';

interface PayExecPayRequest {
  id: number;
  paystatus: string;
  launchDate: string;
  userID: number;
  cliCoreID: number;
  progress: number;
  debug: boolean;
  payExecs: Array<number>;
}

interface PayExecPayState {
  status: string;
  nbCriticalAlert: number;
  nbTotalAlert: number;
  computeDate: string;
}

export enum PayExecType {
  NORMAL = 'NORMAL',
  RETROACTIVITY = 'RETROACTIVITY'
}

/**
 * Attributes for a payExec
 */
export interface PayExecAttributes {
  beginPeriodDate: string;
  endPeriodDate: string;
  payRollSerieName: string;
  payRollPeriodsName: string;
  internationalPayslipAvailable: boolean;
  payRequest: PayExecPayRequest;
  priority: string;
  recall: boolean;
  generatePaySlip: boolean;
  contractID: number;
  cliCoreID: number;
  localeString: string;
  payPeriodContract: number;
  payState: PayExecPayState;
  debug: boolean;
  updatedate: string;
  payTypeName?: string;
  payRollType?: PayExecType;
  originePayExecPayrollPeriodsName?: string;
  originePayExecId?: number;
  retroDiffPayExecId?: number;
  shortId?: number;
  payPeriodContractPayTypeTransId?: string;
  hasRetroPayExecs?: boolean;
  payslipPdfFileId?: number;
  payslipHtmlFileId?: number;
}

export class PayExecWithBeginDate {
  payExec: Data<PayExecAttributes>;
  payPeriodBeginDate: string;
}

/**
 * Attributes for a payResult
 */
export interface PayResultAttributes {
  name: string;
  displayType: string;
  ratio: string;
  rule: string;
  finalRule: boolean;
  begindate: string;
  enddate: string;
  family: string;
  formula: string;
  rawFormulaHtmlEN: string;
  type: string;
  subfamily: string;
  triggerid: string;
  triggertrue: boolean;
  value: number;
  maxEventType: string;
  labelTransId: string;
}

export type PopoverPlacement = 'top' | 'left';

export interface RetroValue {
  family: string;
  subfamily: string;
  rule: string;
  name: string;
  oldValue: number;
  newValue: number;
  displayType: string;
  diff: number;
}

export interface PayTag {
  name: string;
  tags: string;
  beginDate: string,
  endDate: string
}

export interface SanitizedRetroValue {
  family: string;
  subfamily: string;
  rule: string;
  name: string;
  oldValue: string;
  newValue: string;
  displayType: string;
  diff: string;
}
